"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var TabStyles_1 = require("../styles/TabStyles");
var Declarative_1 = require("../utils/Declarative");
var FindIndex_1 = require("../utils/FindIndex");
var DividerWidget_1 = require("./DividerWidget");
var DynamicThemeComponent_1 = require("./DynamicThemeComponent");
var MenuItemWidget_1 = require("./MenuItemWidget");
exports.ListMenuCursorDriftAllowanceMs = 250;
var Colors = TabStyles_1.TabStyles.Colors, Spacing = TabStyles_1.TabStyles.Spacing, Typography = TabStyles_1.TabStyles.Typography;
exports.ListMenuStyles = {
    backgroundColor: Colors.White,
    boxSizing: 'border-box',
    color: Typography.Color.Primary,
    fontSize: Typography.Sizing.Default,
    fontWeight: 'normal',
    lineHeight: 'normal',
    outline: 'none',
    padding: Spacing.DefaultSpace,
    position: 'relative',
};
var isMenuItemEnabled = function (item) { return item && !item.isDivider && !item.disabled && !item.isUnselectable; };
var ListMenuWidget = /** @class */ (function (_super) {
    tslib_1.__extends(ListMenuWidget, _super);
    function ListMenuWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.domRef = React.createRef();
        _this.stopPropagation = function (e) { e.stopPropagation(); };
        _this.xVelocity = 0;
        _this.handleKeyDown = function (e) {
            if (e.altKey || e.ctrlKey || e.metaKey) {
                return;
            }
            if (Declarative_1.isAlphabeticChar(e.key) && !_this.props.letterSearchDisabled) {
                var nextIndexOfFirstLetter_1 = _this.findNextMenuItemStartingWithLetter(e.key);
                if (nextIndexOfFirstLetter_1 > -1) {
                    _this.setActiveItemState(function () { return nextIndexOfFirstLetter_1; }, true);
                }
                e.stopPropagation();
                e.preventDefault();
                return;
            }
            var menuItemCount = _this.props.menuItemInfos.length;
            switch (e.key) {
                case 'ArrowUp':
                    _this.setActiveItemState(function () { return _this.findNextEnabledItemIndex(_this.state.activeItemIndex, -1); }, true);
                    break;
                case 'ArrowDown':
                    _this.setActiveItemState(function () { return _this.findNextEnabledItemIndex(_this.state.activeItemIndex, 1); }, true);
                    break;
                case 'ArrowLeft':
                    if (_this.props.onLeftArrowKeyDown) {
                        _this.props.onLeftArrowKeyDown();
                    }
                    break;
                case 'Home':
                    _this.setActiveItemState(function () { return _this.findNextEnabledItemIndex(-1, 1); }, true);
                    break;
                case 'End':
                    _this.setActiveItemState(function () { return _this.findNextEnabledItemIndex(menuItemCount, -1); }, true);
                    break;
                case ' ':
                case 'Enter':
                    _this.selectActive();
                    break; // let's not scroll the menu or the page
                case 'Escape':
                    break; // eat the keyDown event since we'll handle it in keyUp
                default:
                    // Do not prevent default or stopPropagation on unhandled key presses
                    return;
            }
            e.preventDefault();
            e.stopPropagation();
        };
        _this.handleKeyUp = function (e) {
            if (e.key === 'Escape') {
                if (_this.props.onEscapeKeyUp) {
                    _this.props.onEscapeKeyUp();
                }
                else {
                    _this.props.requestCloseAll();
                }
                e.preventDefault();
                e.stopPropagation();
            }
        };
        _this.clearSubmenu = function (itemIndex) {
            _this.setActiveItemState(function () { return itemIndex; }, false);
        };
        _this.handleItemHover = function (itemIndex) {
            var activeItemIndex = _this.state.activeItemIndex;
            var activeItemIsShowingSubmenu = activeItemIndex === _this.displayedSubmenuItemIndex;
            // TFSID 707410: allow the pointer to stray for 150ms on the way to a submenu
            if (activeItemIsShowingSubmenu && _this.xVelocity >= 2) {
                clearTimeout(_this.submenuTimeoutId);
                _this.submenuTimeoutId = window.setTimeout(_this.clearSubmenu.bind(_this, itemIndex), exports.ListMenuCursorDriftAllowanceMs);
            }
            else {
                _this.clearSubmenu(itemIndex);
            }
        };
        _this.handleItemSelect = function (value) {
            _this.props.onSelect(value);
        };
        _this.handleMouseMove = function (e) {
            _this.xVelocity = _this.oldX !== undefined ? Math.abs(e.pageX - _this.oldX) : 0;
            _this.oldX = e.pageX;
        };
        _this.handleSubmenuShown = function (itemIndex) {
            _this.displayedSubmenuItemIndex = itemIndex;
        };
        _this.state = {
            activeItemIndex: _this.props.__INTERNAL__focusIndex || 0,
            keyboardFocused: true
        };
        return _this;
    }
    ListMenuWidget.prototype.componentDidMount = function () {
        this.addStopPropogationListeners();
    };
    // this is only here for filtering and should be removed when we remove the searchbox support --ckovatch 2018/02/08
    ListMenuWidget.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.menuItemInfos === nextProps.menuItemInfos) {
            return;
        }
        // find previously highlighted string, keep if possible, otherwise select the first item
        var highlightedValue = undefined;
        if (this.state.activeItemIndex > -1 && this.state.activeItemIndex < this.props.menuItemInfos.length) {
            highlightedValue = this.props.menuItemInfos[this.state.activeItemIndex].keyboardAccessibleValue;
        }
        // find new selection index - either previous text selection, or the start of the list
        var newActiveIndex = Math.max(0, FindIndex_1.findIndex(nextProps.menuItemInfos, function (item) { return isMenuItemEnabled(item) && item.keyboardAccessibleValue === highlightedValue; }, 0, this));
        if (this.state.activeItemIndex !== newActiveIndex) {
            this.setState({
                activeItemIndex: newActiveIndex
            });
        }
    };
    ListMenuWidget.prototype.componentWillUnmount = function () {
        this.removeStopPropogationListeners();
    };
    ListMenuWidget.prototype.selectActive = function () {
        if (this.state.activeItemIndex < 0 || this.state.activeItemIndex >= this.props.menuItemInfos.length) {
            console.warn("Tried to select a invalid index: " + this.state.activeItemIndex);
            return;
        }
        var currentItem = this.props.menuItemInfos[this.state.activeItemIndex];
        if (isMenuItemEnabled(currentItem)) {
            this.props.onSelect(currentItem.value);
        }
    };
    /**
     * We stop the propogation of scroll events because components like the dropdown have an event listener on their scrolling
     * root to close the dropdown.  We want the listmenu to be able to scroll without triggering the scrolling root scroll event.
     */
    ListMenuWidget.prototype.addStopPropogationListeners = function () {
        this.domRef.current.addEventListener('scroll', this.stopPropagation);
        this.domRef.current.addEventListener('wheel', this.stopPropagation);
    };
    ListMenuWidget.prototype.removeStopPropogationListeners = function () {
        this.domRef.current.removeEventListener('scroll', this.stopPropagation);
        this.domRef.current.removeEventListener('wheel', this.stopPropagation);
    };
    ListMenuWidget.prototype.findNextEnabledItemIndex = function (currentIndex, direction) {
        var menuItemCount = this.props.menuItemInfos.length;
        for (var i = currentIndex + direction; i !== currentIndex; i += direction) {
            if (i >= menuItemCount) {
                i = 0;
            }
            else if (i < 0) {
                i = menuItemCount - 1;
            }
            if (i === currentIndex) {
                return currentIndex;
            }
            if (isMenuItemEnabled(this.props.menuItemInfos[i])) {
                return i;
            }
        }
        return currentIndex;
    };
    ListMenuWidget.prototype.findNextMenuItemStartingWithLetter = function (letter) {
        return FindIndex_1.findIndex(this.props.menuItemInfos, function (item) {
            return isMenuItemEnabled(item) && item.keyboardAccessibleValue &&
                item.keyboardAccessibleValue.charAt(0).toUpperCase() === letter.charAt(0).toUpperCase();
        }, this.state.activeItemIndex + 1, this);
    };
    ListMenuWidget.prototype.setActiveItemState = function (activeItemIndex, keyboardFocused) {
        var _this = this;
        clearTimeout(this.submenuTimeoutId);
        this.setState(function (prevState, props) { return ({ activeItemIndex: activeItemIndex(), keyboardFocused: keyboardFocused }); }, function () {
            _this.displayedSubmenuItemIndex = undefined;
            if (!_this.state.keyboardFocused && !_this.props.letterSearchDisabled) {
                // If no individual item is focused, ensure focus is still on the menu so keyboard input is received
                _this.domRef.current.focus();
            }
        });
    };
    ListMenuWidget.prototype.shouldShowCheckGutter = function () {
        for (var i = 0; i < this.props.menuItemInfos.length; i++) {
            if (typeof this.props.menuItemInfos[i].checked !== 'undefined') {
                return true;
            }
        }
        return false;
    };
    ListMenuWidget.prototype.buildMenuFromMenuItemInfos = function () {
        var _this = this;
        var showCheckGutter = this.shouldShowCheckGutter();
        return this.props.menuItemInfos.map(function (item, index) {
            if (item.isDivider) {
                return React.createElement(DividerWidget_1.DividerWidget, { key: index });
            }
            else {
                if (!item.value) {
                    throw new Error("Each non-divider menu item requires a value");
                }
                return (React.createElement(MenuItemWidget_1.MenuItemWidget, { checked: item.checked, disabled: item.disabled, displayFormatterBoundWithData: item.displayFormatterBoundWithData, isHighlighted: !item.disabled && !item.isUnselectable && _this.state.activeItemIndex === index, isUnselectable: item.isUnselectable, itemIndex: index, key: index, keyboardFocused: _this.state.keyboardFocused && !_this.props.focusDisabled, menuItemInfos: item.menuItemInfos, onHover: item.disabled || item.isUnselectable ? null : _this.handleItemHover, onSelect: _this.handleItemSelect, onSubmenuShown: _this.handleSubmenuShown, requestCloseAll: _this.props.requestCloseAll, role: Declarative_1.conditional(_this.props.role === 'listbox', 'option'), scrollingRootId: _this.props.scrollingRootId, showCheckGutter: showCheckGutter, stackingRootId: _this.props.stackingRootId, subMenuAllowAutoPosition: _this.props.subMenuAllowAutoPosition, subMenuMaxHeight: item.subMenuMaxHeight, subMenuShouldAutoPositionOnScrollingRootScroll: _this.props.subMenuShouldAutoPositionOnScrollingRootScroll, subMenuStyle: item.subMenuStyle, testId: _this.props.testId, value: item.value, zIndex: _this.props.zIndex }));
            }
        });
    };
    ListMenuWidget.prototype.render = function () {
        var style = tslib_1.__assign({}, exports.ListMenuStyles, this.props.menuStyle, Declarative_1.conditional(!!this.props.maxHeight, {
            maxHeight: this.props.maxHeight,
            overflowY: 'auto',
            WebkitOverflowScrolling: 'touch',
        }));
        return (React.createElement("div", { "data-tb-test-id": this.props.testId + "-ListMenu", id: this.props.id, onKeyDown: this.handleKeyDown, onKeyUp: this.handleKeyUp, onMouseEnter: this.props.onMouseEnter, onMouseMoveCapture: this.handleMouseMove, ref: this.domRef, role: this.props.role, style: style, tabIndex: -1 }, this.buildMenuFromMenuItemInfos()));
    };
    return ListMenuWidget;
}(DynamicThemeComponent_1.DynamicThemeComponent));
exports.ListMenuWidget = ListMenuWidget;
//# sourceMappingURL=ListMenuWidget.js.map